import { useState } from "react";

interface UsePasswordVisibilityProps {
  initialStates?: Record<string, boolean>;
}

export const usePasswordVisibility = ({ initialStates = {} }: UsePasswordVisibilityProps = {}) => {
  const [visibilityStates, setVisibilityStates] = useState<Record<string, boolean>>(initialStates);

  const toggleVisibility = (fieldName: string) => {
    setVisibilityStates((prev) => ({
      ...prev,
      [fieldName]: !prev[fieldName],
    }));
  };

  const setVisibility = (fieldName: string, isVisible: boolean) => {
    setVisibilityStates((prev) => ({
      ...prev,
      [fieldName]: isVisible,
    }));
  };

  return {
    visibilityStates,
    toggleVisibility,
    setVisibility,
  };
};
